import { Box, styled } from "@mui/material";
import { brighthiveTheme } from "../../../../../theme/theme";

export const ChatRcvBotDescription = styled(Box)`
  width: fit-content;
  max-width: 560px;
  border-radius: 0 8px 8px 8px;
  padding: 12px 18px;
  color: ${brighthiveTheme.palette.common.black};
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.25px;
  border: 1px solid ${brighthiveTheme.palette.custom.contrastText};
  word-break: break-word;

  @media (min-width: 992px) {
    padding-left: 24px;
    padding-right: 24px;
    border-radius: 0 12px 12px 12px;
  }

  p {
    a {
      color: ${brighthiveTheme.palette.link.main};
      text-decoration: none;

      &:hover {
        color: ${brighthiveTheme.palette.common.black};
      }
    }
  }

  .reasoning-update {
    display: flex;
    align-items: center;
    font-style: italic;
    color: #555;

    /* Style for emoji at the beginning of reasoning updates */
    p {
      margin: 0;
      display: flex;
      align-items: center;
    }

    /* Make emojis slightly larger */
    p > span:first-child {
      font-size: 18px;
      margin-right: 8px;
    }

    /* Subtle animation for typing effect */
    @keyframes typing {
      0% {
        opacity: 0.5;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0.5;
      }
    }

    &::after {
      content: "...";
      animation: typing 1.5s infinite;
      margin-left: 4px;
    }
  }
`;

export const ChatRcvBotWidgetWrapper = styled("div")`
  display: flex;
  gap: 8px;
  margin-top: 24px;
`;
